import { Star, Quote } from 'lucide-react';

const TESTIMONIALS = [
  {
    id: '1',
    name: 'Sophie A.',
    comment: "Exceptional service! Punctual, professional, and the vehicle was immaculately clean.",
  },
  {
    id: '2',
    name: 'James W.',
    comment: "Outstanding experience. Flight was delayed but the driver was there waiting for us.",
  },
  {
    id: '3',
    name: 'Maria G.',
    comment: "Simple booking, professional driver, perfect Mercedes S-Class for business travel.",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="text-primary uppercase tracking-widest text-sm font-medium">Testimonials</span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mt-3">
            Trusted by Hundreds of Clients
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {TESTIMONIALS.map((testimonial) => (
            <div 
              key={testimonial.id} 
              className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/10"
            >
              <Quote className="w-8 h-8 text-primary mb-4" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-primary fill-primary" />
                ))}
              </div>
              <p className="text-white/90 mb-4 text-sm leading-relaxed">
                "{testimonial.comment}"
              </p>
              <p className="text-primary font-medium text-sm">{testimonial.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
